import React, { useContext } from "react";

import { css } from "@emotion/core";

import { DataContext as CalculatorContext } from "../../../../../providers/PelletsDataProvider";
import Margin from "../../../../shared/Margin";
import Headline from "../../../../shared/NewHeadline";
import Section from "../../../../shared/Section";
import Comment from "./Comment";
import DeliveryTime from "./DeliveryTime";
import Hose from "./Hose";
import PromotionCode from "./PromotionCode";

const StepDeliveryDetails = () => {
    const calculatorContext = useContext(CalculatorContext);

    const { additions, product } = calculatorContext.data;

    return (
        additions && (
            <>
                <Section>
                    <DeliveryTime />

                    {additions.hoses &&
                        Object.keys(additions.hoses).length > 0 && (
                            <Section withMargin>
                                <Margin Component={Headline} top="20">
                                    Lieferdetails
                                </Margin>
                                <Hose />
                            </Section>
                        )}

                    <Section withMargin>
                        <Comment />
                    </Section>
                    <Section withMargin>
                        <PromotionCode />
                    </Section>
                    {product !== "loose" && (
                        <Section
                            withMargin
                            css={css`
                                font-size: 0.75rem;
                            `}
                        >
                            <p>
                                Frei Bordsteinkante geliefert. Wir sind jedoch
                                bemüht, per Hubgerät die Ware zur gewünschten
                                Endposition, auf kundenseitiges Risiko, zu
                                platzieren.
                            </p>
                        </Section>
                    )}
                </Section>
            </>
        )
    );
};

export default StepDeliveryDetails;
